const AUTO_OPEN_DELAY = 1200;

export const initNativeAppHandoff = () => {
  const appLink = document.querySelector('[data-native-app-handoff-auto-open]');
  if (!appLink) return;

  const timeout = setTimeout(() => {
    location.assign(appLink.href);
  }, AUTO_OPEN_DELAY);

  for (const link of document.querySelectorAll('.native-app-handoff a')) {
    link.addEventListener('click', () => clearTimeout(timeout), { once: true });
  }
};
